import React from "react";
import { Dialog, DialogContent } from "./ui/dialog";

const VideoDialog = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[900px] p-0 overflow-hidden bg-black border-none">
        <div className="aspect-video w-full">
          {open && (
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/BaltboqE_ow?autoplay=1&rel=0"
              title="STUDYGRI presentation"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VideoDialog;
